import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Platform} from '@angular/cdk/platform';


@Component({
    selector: 'soa-tablet',
    templateUrl: './soa-tablet.component.html',
    styleUrls: ['./soa-tablet.component.scss']
})
export class SoaTabletComponent implements OnInit {

    @Input() filteredStatements: any;
    @Output() emitActions: EventEmitter<any> = new EventEmitter<any>();

    constructor(public platform: Platform) {
    }

    ngOnInit(): void {
    }

    handleClickActions(actionFrom: any, statement: any) {
        this.emitActions
            .emit({
                actionFrom,
                statement
            });
    }

}
